import { render, staticRenderFns } from "./Arbeitszeit.vue?vue&type=template&id=fa8b8c70&"
import script from "./Arbeitszeit.vue?vue&type=script&lang=js&"
export * from "./Arbeitszeit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports